module.exports = __webpack_public_path__ + "static/media/seller3.8d771f42.jpg";